const config = {
  // env: "prod",
  // env: 'testbed',
  // env: "uat",
  env: "sit",
};

export default config;
